





















import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import List from './List.vue'
import { filterColumnsByPermission } from '@/utils/helper/permission'

@Component({
	name: 'partnerOrderList',
	components: {
		PageLayout,
		List,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = filterColumnsByPermission(columns)
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	public getList() {
		return PartnerApi.getOrderList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form = (this.$refs.list as any).getForm()

		return form
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		PartnerApi.exportOrderList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
